import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Notification, NotificationLevel } from '@steelbuy/ui-primitive';
import { RoutePath } from '../../router/Routes';
import { TableLayout } from '../../views/layouts/table-layout/TableLayout';
import { PageHeader } from '../page-header/PageHeader';

export const SellerListingDetailsNotFound = () => {
    const { t } = useTranslation('translation');
    const navigate = useNavigate();

    return (
        <>
            <PageHeader
                pageTitle={t('application.sellerListingDetailsNotFound.pageTitle')}
                previousPageTitle={t('application.sellerListingDetailsNotFound.previousPageTitle')}
                onBackClick={() => navigate(RoutePath.MY_LISTINGS)}
            />

            <TableLayout>
                <Notification
                    level={NotificationLevel.WARNING}
                    message={t('application.sellerListingDetailsNotFound.notFoundMessage')}
                />
            </TableLayout>
        </>
    );
};
